module.exports = __webpack_public_path__ + "static/media/empty_room_availability_image.41b86ffc.svg";